export const SettingsToolTypes = ['Bridges', 'Exchanges'];
//# sourceMappingURL=types.js.map